import { createContext } from "react";

const ConfiguratorContext = createContext({});

export default ConfiguratorContext;
